import { React,useState,useRef,useEffect } from 'react'
import {Container ,Row,Col} from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import products from '../assets/data/products'
import Helmet from '../components/Helmet/Helmet'
import CommonSection from '../components/UI/CommonSection'
import { motion } from 'framer-motion'
import ProductList from '../components/UI/ProductList'
import { useDispatch } from 'react-redux'
import { cartActions } from '../redux/slices/cartSlice'
import { toast } from 'react-toastify'

import '../assets/style/product-details.css'


const ProductDetails = () => {

  const {id} = useParams()
  const product = products.find(item=>item.id === id)
  const {imgUrl,productName,price,avgRating,shortDesc,reviews,description,category} = product

  const relatedProducts = products.filter(item=>item.category===category)

  const [rating,setRating] = useState(null)
  const [tab,setTab] = useState('desc')

  const reviewUser = useRef('')
  const reviewMsg = useRef('')

  const submitHandler = (e)=>{
    e.preventDefault()

    const reviewUserName = reviewUser.current.value
    const reviewUserMsg = reviewMsg.current.value
    const reviewObj = {
      userName:reviewUserName,
      text:reviewUserMsg,
      rating,
    }
    console.log(reviewObj)
    toast.success('Review Submitted')
  }

  const dispatch = useDispatch()

  const addToCart =()=>{
    dispatch(cartActions.addItem({
      id,
      image:imgUrl,
      productName,
      price,
    })
    )
    toast.success('Add To Cart')
  }

  useEffect(()=>{
    window.scrollTo(0,0);
  },[product])

  return (
    <>
      <Helmet title={productName}/>
      <CommonSection title={productName}/>

        <section className='pt-0'>
            <Container>
              <Row>
                <Col lg='6'>
                  <img src={imgUrl} alt="product" />
                </Col>
                <Col lg='6'>
                  <div className="product__details">
                    <h2>{productName}</h2>

                    <div className='product__rating mb-3 d-flex gap-3 align-items-center'>
                      <div>
                        <span><i className='ri-star-s-fill'></i></span>
                        <span><i className='ri-star-s-fill'></i></span>
                        <span><i className='ri-star-s-fill'></i></span>
                        <span><i className='ri-star-s-fill'></i></span>
                        <span><i className='ri-star-s-fill'></i></span>
                      </div>
                      <p>(<span>{avgRating}</span> ratings)</p>
                    </div>

                    <div className='d-flex flex-column gap-2'>
                      <span className='product__price'>${price}</span>
                      <p className='product__price'>Category : {category}</p>
                    </div>
                    <p className='mt-3'>{shortDesc}</p>
                    <motion.button onClick={addToCart} whileTap={{scale:1.1}} className='buy__btn'>Add to Cart</motion.button>
                  </div>
                </Col>
              </Row>
            </Container>
        </section>

        <section>
          <Container>
            <Row>
              <Col lg='12'>
                <div className='tab__wrapper d-flex align-items-center gap-5'>
                  <h6 className={`${tab==='desc'?'active__tab':''}`}
                    onClick={()=>setTab('desc')}
                  >
                    Description
                  </h6>
                  <h6 className={`${tab==='rev'?'active__tab':''}`}
                    onClick={()=>setTab('rev')}
                  >
                    Reviews ({reviews.length})
                  </h6>
                </div>

                {
                  tab === 'desc' ? 
                  <div className='tab__content mt-5'>
                    <p>{description}</p>
                  </div>
                  :
                  <div className='product__review mt-5'>
                    <div className="review__wrapper">

                      <ul>
                        {
                          reviews?.map((item,index)=>{
                            return(
                              <li key={index} className='mb-4'>
                                <h6>Ahmed Mohamed</h6>
                                <span>{item.rating} (Rating)</span>
                                <p>{item.text}</p>
                              </li>
                            )
                          })
                        }
                      </ul>

                      <div className='review__form'>
                        <h4>Leave your Experience</h4>

                        <form action="" onSubmit={submitHandler}>
                          <div className='form__group'>
                            <input required ref={reviewUser} type="text" placeholder='Enter Name' />
                          </div>

                          <div className='form__group rating__group d-flex align-items-center'>
                            <motion.span whileTap={{scale:1.2}} onClick={()=>setRating(1)}>1 <i className='ri-star-s-fill'></i></motion.span>
                            <motion.span whileTap={{scale:1.2}} onClick={()=>setRating(2)}>2 <i className='ri-star-s-fill'></i></motion.span>
                            <motion.span whileTap={{scale:1.2}} onClick={()=>setRating(3)}>3 <i className='ri-star-s-fill'></i></motion.span>
                            <motion.span whileTap={{scale:1.2}} onClick={()=>setRating(4)}>4 <i className='ri-star-s-fill'></i></motion.span>
                            <motion.span whileTap={{scale:1.2}} onClick={()=>setRating(5)}>5 <i className='ri-star-s-fill'></i></motion.span>
                          </div>

                          <div className='form__group'>
                            <textarea required ref={reviewMsg} rows={4} type="text" placeholder='Review Message ...' />
                          </div>

                          <motion.button whileTap={{scale:1.2}} type='submit' className='buy__btn'>Submit</motion.button>

                        </form>
                      </div>

                    </div>

                  </div>
                }
              </Col>

              <Col lg='12' className='mt-5'>
                <h2 className='related__title'>
                  You might also like
                </h2>
                <ProductList data={relatedProducts}/>
              </Col>

            </Row>
          </Container>
        </section>
    </>
  )
}

export default ProductDetails